export { default } from './ModuleInfo';

